<style scoped>
.svgContent {
  width: 100%;
  text-align: center;
  -webkit-transform: translateZ(0);
  -moz-transform: translateZ(0);
  -ms-transform: translateZ(0);
  -o-transform: translateZ(0);
  transform: translateZ(0);

  -webkit-transform: translate3d(0,0,0);
  -moz-transform: translate3d(0,0,0);
  -ms-transform: translate3d(0,0,0);
  -o-transform: translate3d(0,0,0);
  transform: translate3d(0,0,0);

  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;

  -webkit-perspective:1000;
  perspective:1000;

  -webkit-transform-style: preserve-3d;
  transform-style: preserve-3d;
}
.svgTitle{
  background-color: black;
  height: 100px;
  color: white;
  text-align: center;
  padding-top: 30px;
}
.lineOpen{
  position: fixed;
  outline: 0;
  left: 10px;
  top: 20px;
  z-index: 999;
}
.svginfo{
  position: fixed;
  outline: 0;
  right:  10px;
  top: 20px;
  z-index: 999;
}
.svgFooter{
  position: fixed;
  bottom: 0px;
  width: 100%;
}
</style>

<template>
    <div>
        <header v-title data-title="抖音版地铁线路开通历程图"/>

        <!-- <div class="svgTitle">
          <h1>{{cityName}}地铁线路开通历程图</h1>
        </div> -->

        <div v-if="currentChoosetTime!==''"  class="lineOpen">
          <h1>{{currentChoosetTime}}</h1>
          <p v-for="(content,index) in computedTimeContent(currentChoosetTime)" :key="index" style="font-size: 18px;">
            {{content}}
          </p>
        </div>

        <div v-if="currentChoosetTime!==''" class="svginfo">
          <h2>线路: {{total.line}}条</h2>
          <h2>站点: {{total.station}}站</h2>
          <h2>里程: {{total.distance}}KM</h2>
        </div>

        <div v-html="svgHtml" id="svgWorkPlatform" class="svgContent"></div>

        <van-row class="svgFooter">
          <van-col span="12">
            <van-button size="large" :icon="beginPlay?'pause':'play'" type="default" @click="handlePlayOrPause">
                <span v-if="beginPlay">暂停历程</span>
                <span v-else>开始播放</span>
            </van-button>

            <!-- 背景音乐 -->
            <audio :src="bgsround" controls="controls" loop preload id="music1" hidden></audio>
          </van-col>
          <van-col span="12">
            <van-button size="large" type="default" icon="bars" @click="showCitys=true">切换城市</van-button>
          </van-col>
        </van-row>

        <van-popup v-model="showCitys" position="right" round  :style="{ height: '100%', width:'50%' }">
          <van-index-bar :index-list="cityGroup">
            <template v-for="(group,index) in cityGroup">
              <van-index-anchor :key="index" :index="group">
                <span class="remark">{{group}}</span>
              </van-index-anchor>
              <van-cell v-for="city in citys.filter(x=>x.group === group)" :title="city.name" :key="city.code" @click="handleChangeCity(city)"/>
            </template>
          </van-index-bar>
        </van-popup>

    </div>
</template>

<script>
import '@vant/touch-emulator' // 用于解决web端模拟移动端的触摸事件

import { Button, Col, Row, Popup, Picker, IndexBar, IndexAnchor, Cell, Toast, Icon } from 'vant'
import { mapOperation } from '@/utils/mapOperation'
import { getStationOpenStatistics } from '@/api/station'

export default {
  mixins: [mapOperation], // 混入地图操作的方法
  components: {
    [Button.name]: Button,
    [Col.name]: Col,
    [Row.name]: Row,
    [Popup.name]: Popup,
    [IndexBar.name]: IndexBar,
    [IndexAnchor.name]: IndexAnchor,
    [IndexAnchor.name]: IndexAnchor,
    [Cell.name]: Cell,
    [Icon.name]: Icon,
    [Picker.name]: Picker

  },
  data () {
    return ({
      bgsround: require('@/assets/platform/巴赫平均律.mp3'),
      hideLineNumber: true,
      bgAudio: null,
      pageType: 1, // 用于JS文件中，标识线路开通历程，2标识线路选中
      spinShow: false,
      svgHtml: '',

      beginPlay: false,
      stationOpenStatistic: [],
      playIndex: -1, // 播放序列
      currentChoosetTime: '',

      showCitys: false,
      cityName: '',
      chooseCity: '',
      citys: this.$store.state.main.mapCitys,
      cityGroup: [],

      total: {
        line: 0,
        station: 0,
        distance: 0
      }
    })
  },
  mounted () {
    this.formatCityData()
    this.initPageData()
    // 设置中间区域地图高度
    this.$nextTick(() => {
      document.getElementById('svgWorkPlatform').style.height = document.documentElement.clientHeight + 'px'
      this.bgAudio = document.getElementById('music1')
    })
  },
  methods: {
    formatCityData () {
      if (this.$route.params.id && this.citys.find(x => x.code === this.$route.params.id)) {
        this.chooseCity = this.$route.params.id
        this.cityName = this.citys.find(x => x.code === this.$route.params.id).name
      } else {
        this.chooseCity = this.citys[this.citys.length - 1].code
        this.cityName = this.citys[this.citys.length - 1].name
      }

      let group = []
      this.citys.forEach(element => {
        if (group.indexOf(element.group) === -1) {
          group.push(element.group)
        }
      })
      this.cityGroup = group.sort()
    },
    initPageData (cityName) {
      this.initMap(cityName)
      this.loadStationOpenData()
    },
    loadStationOpenData () {
      const data = { cityCode: this.chooseCity }

      getStationOpenStatistics(data).then(res => {
        this.stationOpenStatistic = res.sort(function (a, b) {
          return a.openDate > b.openDate ? 1 : -1
        })
      })
    },
    autoReplayTime () {
      if (this.playIndex + 1 === this.stationOpenStatistic.length) {
        this.beginPlay = false
        this.playIndex = -1
        return
      }

      this.playIndex++
      setTimeout(() => {
        if (this.beginPlay) {
          this.autoReplayTime()
        }
      }, 2000)
    },
    computedTimeContent (time) { // 显示文本， 地铁开通内容
      let timeContent = []

      // 可能是同一时间，开通多条线路
      const timeInfo = this.stationOpenStatistic.filter(x => x.openDate === time)
      timeInfo.forEach(element => {
        const assetName = element.assetName.substr(element.assetName.indexOf('铁') + 1)

        let number = ''
        if (this.stationOpenStatistic.filter(x => x.assetId === element.assetId).length > 1) {
          number = element.issue + '期'
        }

        timeContent.push(assetName + number)
      })

      return timeContent
    },
    handleChangeCity (city) {
      if (city.code !== this.chooseCity) {
        this.chooseCity = city.code
        this.cityName = city.name
        this.playIndex = -1
        this.bgAudio.currentTime = 0 // 设置背景音乐到0秒位置
        this.beginPlay = false
        this.initPageData(city.name)
        this.currentChoosetTime = ''
      }
      this.showCitys = false
    },
    handlePlayOrPause () {
      this.beginPlay = !this.beginPlay
      if (this.beginPlay) {
        this.autoReplayTime()
      }
    }
  },
  watch: {
    playIndex (val) {
      if (val === -1) {
        return
      } else if (val === 0) { // 地图初始播放是， 全部隐藏线路
        this.hideMapLines([], [])
      }

      // 先锚点线路
      let currentAsset = this.stationOpenStatistic[val]
      let currentAssetStations = currentAsset.stations.split(',')
      let lineOpen = {
        id: currentAsset.assetId,
        centerStationId: currentAssetStations[parseInt(currentAssetStations.length / 2)]
      }
      this.handleMapGetCenter(lineOpen, false)
      this.currentChoosetTime = this.stationOpenStatistic[val].openDate

      // 获取需要显示的线路ID
      let showStationList = []
      let showAssetList = []

      for (let index = 0; index < val + 1; index++) {
        showAssetList.push(this.stationOpenStatistic[index])
        showStationList = showStationList.concat(this.stationOpenStatistic[index].stations.split(','))
      }

      let openAsset = []
      showAssetList.forEach(element => {
        if (!openAsset.includes(element.assetId)) {
          openAsset.push(element.assetId)
        }
      })

      let openDistance = 0
      openAsset.forEach(element => {
        openDistance += showAssetList.find(x => x.assetId === element).length
      })

      // 延迟1秒点亮线路
      setTimeout(() => {
        this.hideMapLines(showAssetList, showStationList)
        this.total.line = openAsset.length
        this.total.station = showStationList.length
        this.total.distance = openDistance.toFixed(1)
      }, 830)
    },
    beginPlay (val) {
      if (val) {
        this.bgAudio.play()
      } else {
        this.bgAudio.pause()
      }
    },
    spinShow (val) {
      if (val) {
        Toast.loading({
          message: '地图加载中...',
          forbidClick: true,
          loadingType: 'spinner',
          duration: 0
        })
      } else {
        Toast.clear()
      }
    }
  }
}
</script>
